import AppColorStore from "Stores/AppColor/AppColorStore";
import { connect } from 'react-redux';
import { RectangleControl } from '../Presentational/index';
import {
    handleDragEnd, handleAnchorDragStart, handleRectAnchorUp, handleRectAnchorDrag, handleDeleteAnnotationDrawing, handleToggleContextMenu,
    handleDragStart, handleDragMove
} from '../../../../../../Actions/AnnotationActions';
import React, { Component } from 'react';

class GraphicsRectangle extends Component {

    componentDidMount() {
        AppColorStore.addChangeListener(this.AppColorStoreStateChanged);
    }

    componentWillUnmount() {
        AppColorStore.removeChangeListener(this.AppColorStoreStateChanged);
    }

    AppColorStoreStateChanged = () => {
        this.forceUpdate();
    }

    render() {
        const { rectangle, index, lockImage, isApiReqResolved } = this.props;
        const shapesModelInfo = this.props.shapesModelInfo;
        const { isDragging, activeAnchor, selectedAnnotId } = this.props.annotationChartModelReducer;
        return (

            <RectangleControl
                onContextMenu={this.props.onContextMenu}
                key={index}
                index={index}
                rectangle={rectangle}
                shapesModelInfo={shapesModelInfo}
                isDragging={isDragging}
                selectedAnnotId={selectedAnnotId}
                activeAnchor={activeAnchor}
                handleDragStart={this.props.handleDragStart}
                handleDragMove={this.props.handleDragMove}
                handleDragEnd={this.props.handleDragEnd}
                handleAnchorDragStart={this.props.handleAnchorDragStart}
                handleAnchorDragEnd={this.props.handleAnchorDragEnd}
                handleAnchorDragMove={this.props.handleAnchorDragMove}
                draggable={this.props.draggable}
                lockImage={lockImage}
                isApiReqResolved={isApiReqResolved}
                handleDeleteAnnotationDrawing={this.props.handleDeleteAnnotationDrawing}
            />

        );
    }
}

const mapStateToProps = ({ annotationReducers }) => {
    const { rectangleReducer, annotationChartModelReducer } = annotationReducers;
    const shapesModelInfo = annotationReducers.annotationMenuReducer.ShapesModelInfo
    return ({ rectangleReducer, shapesModelInfo, annotationChartModelReducer });
}

const mapDispatchToProps = (dispatch) => ({
    handleDragStart: (rect) => dispatch(handleDragStart(rect)),
    handleDragMove: (e) => dispatch(handleDragMove(e)),
    handleDragEnd: () => handleDragEnd(),
    handleAnchorDragStart: (anchor) => dispatch(handleAnchorDragStart(anchor)),
    handleAnchorDragEnd: () => dispatch(handleRectAnchorUp()),
    handleAnchorDragMove: (e) => dispatch(handleRectAnchorDrag(e)),
    handleDeleteAnnotationDrawing: (charCode) => { dispatch(handleDeleteAnnotationDrawing(charCode)), dispatch(handleToggleContextMenu(false, 0, 0, '')) }
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphicsRectangle);